import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Planning\UpdateAssignedPeopleController::__invoke
* @see app/Http/Controllers/Planning/UpdateAssignedPeopleController.php
* @route '/api/planning/{event}/people'
*/
const UpdateAssignedPeopleController = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateAssignedPeopleController.url(args, options),
    method: 'put',
})

UpdateAssignedPeopleController.definition = {
    methods: ["put"],
    url: '/api/planning/{event}/people',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Planning\UpdateAssignedPeopleController::__invoke
* @see app/Http/Controllers/Planning/UpdateAssignedPeopleController.php
* @route '/api/planning/{event}/people'
*/
UpdateAssignedPeopleController.url = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { event: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { event: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            event: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        event: typeof args.event === 'object'
        ? args.event.id
        : args.event,
    }

    return UpdateAssignedPeopleController.definition.url
            .replace('{event}', parsedArgs.event.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Planning\UpdateAssignedPeopleController::__invoke
* @see app/Http/Controllers/Planning/UpdateAssignedPeopleController.php
* @route '/api/planning/{event}/people'
*/
UpdateAssignedPeopleController.put = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateAssignedPeopleController.url(args, options),
    method: 'put',
})

export default UpdateAssignedPeopleController